<template>
	<div v-if="material" class="px-0 col-12">
		<div class="ml-auto pl-0 col-8">
			<blocker-product-table :product-id="material.product.id" class="mt-3" />
			<blocker-manual-table
				:product-id="material.product.id"
				:material-id="material.id"
				:asin="material.asin"
				v-on:saveEvent="reloadBlockerComputed"
				class="my-3"
			/>

			<div v-if="material != null">
				<material-stock-listings-editor
					ref="materialStockListingsEditor"
					:authorization="authorization"
					:passed-material="material"
					:is-master="master"
					:userName="userName"
          :users="users"
				></material-stock-listings-editor
				><!-- isMaster -->
			</div>
		</div>
		<div
			v-if="material != null"
			class="col-4 pr-3 mt-3"
			style="position: fixed; top:59px; z-index:2;}"
		>
			<div class="mb-3">
				<form @submit="materialSearchFunction">
					<div class="input-group d-flex">
						<input
							type="text"
							style="text-align: left"
							v-bind:class="{
								'bg-danger': materialSearch.answer == false ? true : false,
								'form-control': true,
								'form-control-sm': true,
							}"
							placeholder="EAN / ASIN"
							v-model="materialSearch.code"
							ref="refEanSearch"
						/>
						<div class="input-group-append">
							<button class="btn btn-secondary btn-sm">Suchen</button>
						</div>
					</div>
				</form>
			</div>
			<div class="mb-1">
				<material-history-component :materialId="materialId"/>
			</div>
			<div class="card" v-bind:style="{ height: tHeight + 'px' }">
				<div class="card-body" style="overflow-y: scroll">
					<material-edit-component
						:passed-material="materialEditMaterial"
						:passed-product="material.product"
					></material-edit-component>
					<meta-data-base-editor
						:passed-product="material.product"
						:passed-current-user="userName"
					></meta-data-base-editor>
				</div>
			</div>
		</div>

		<div>
			<!-- modal search wait dialogue-->
			<b-modal
				v-model="modalEanSearchState"
				size="sm"
				centered
				hide-footer
				hide-header
				no-close-on-esc
				no-close-on-backdrop
			>
				<div class="modal-body">
					<div class="text-center justify-content-between">Bitte Warten</div>
					<div class="row">
						<br /><br /><br />
						<div
							class="spinner-border text-center justify-content-between"
							style="
								position: fixed;
								z-index: 999;
								height: 3em;
								width: 3em;
								overflow: visible;
								margin: auto;
								top: 50px;
								left: 0;
								bottom: 0;
								right: 0;
							"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
					</div>
				</div>
			</b-modal>
		</div>
	</div>
</template>

<script>
export default {
	props: ["materialId", "userName", "isMaster", "userRole"],
	data() {
		return {
			showingBlockerProductTable: true,
			material: null,
			materialEditMaterial: null,
			modalError: {
				state: false,
				message:
					"Der axios.get() Vorgang konnte aufgrund des folgenden Fehlers nicht ausgeführt werden:",
				error: "",
			},
			modalEanSearchState: false,
			materialSearch: {
				code: null,
				answer: null,
			},
			tHeight: window.innerHeight - 140,
			master: this.isMaster,
      users: [],
		};
	},
	methods: {
		reloadBlockerComputed() {
			this.$refs.materialStockListingsEditor.reloadBlockerComputed();
		},
		materialSearchFunction(event) {
			event.preventDefault();
			this.modalEanSearchState = true;
			axios
				.get("/material/exists", { params: { code: this.materialSearch.code } })
				.then((response) => {
					this.modalEanSearchState = false;
					this.materialSearch.answer = response.data;
					if (this.materialSearch.answer != false) {
						window.location.replace(
							"/material/" + this.materialSearch.answer.id + "/edit"
						);
					}
				})
				.catch((error) => {
					console.dir(error);
					this.modalEanSearchState = false;
					this.modalError.error = error.toString();
					this.modalError.state = true;
				});
		},
        updateStock(_stock){
		// console.log("MaterialInterface");
		
        }		
	},
	created() {
		Promise.all([
			axios.get("/material/get", { params: { materialId: this.materialId } }),
			axios.get(`/material/get_blocked_vendor_stocks/${this.materialId}`),
			axios.get("/user/authorization"),
      axios.get("/material/get_blockable_vendorIds"),
      axios.get(`/material/get_last_manual_vendor_orders/${this.materialId}`),
      axios.get(`/user/all`),
		])
			.then(([response, vsbResponse, authorizationResponse, bvResponse, mhResponse, usersResponse]) => {
				// console.log(vendorStockBlocksStocks);
				this.material = response.data;

				let blockedVendorStocks = vsbResponse.data;

				this.authorization = authorizationResponse.data;
				let debugVendorId = 11;
				let blockableVendorIds = bvResponse.data;
        this.users = usersResponse.data;
        this.material.materialHistory = mhResponse.data;

        if(this.material.materialHistory.length > 0){

          this.material.materialHistory.map(mh => {

            let data = JSON.parse(mh.diff);
            mh.manualOrderQuantity = data.new["manuelle Bestellung"];
            mh.manualOrderReference = data.old["manuelle Bestellung"];
            return mh;
          })
        }


        console.log(this.material)
				// for(let k = 0; k < this.material.stocks; ++k)
				// {
				// 	if(this.material.stocks[k].vendorId == debugVendorId ) { //65border music; gardner used 17;
				// 		console.log("bruh");
				// 		console.log(this.material.stocks[k]);
				// 	}
				// 	this.material.stocks[k].vendorStockBlock = this.material.stocks[k].vendorstockblock;
				// 	delete this.material.stocks[k].vendorstockblock;
				// 	if(this.material.stocks[k].vendorId == debugVendorId) {
				// 		console.log("after");
				// 		console.log(stock);
				// 	}
				// }
				for (let stock of this.material.stocks) {
					// if(stock.vendorId == debugVendorId ) { //65border music; gardner used 17;
					// 	console.log("bruh");
					// 	console.log(stock);
					// }
					// stock.vendorStockBlock = stock.vendorstockblock;
					// delete stock.vendorstockblock;
					// if(stock.vendorId == debugVendorId) {
					// 	console.log("after");
					// 	console.log(stock);
					// }
					// for(let dataset of blockedVendorStocks){
					// 	if(stock.id == dataset.stockId){
					// 		console.log('matched id');
					// 	}
					// }

					let matchedStockBlock = blockedVendorStocks.find(
						vsb => vsb.stockId === stock.id
					);
					// console.log(matchedStockBlock);
					//weil vendorStockBlock nach initialisierung hinzugefügt wurde, wird es hier reactive gemacht
					this.$set(stock, 'vendorStockBlock', (matchedStockBlock == undefined ? false : true));
					this.$set(stock, 'blockableVendorIds', blockableVendorIds);

				}
				/*
				this.material.stocks.map( stock => {
					stock.vendorStockBlock = vendorStockBlocks.find( vsb => vsb.vendorId == vendor.id );
				});
*/
				var categoryNames = {
					'-1': "FORBIDDEN",
					0: "Unknown",
					1: "Music",
					2: "Movie",
					3: "Book",
					4: "Toy",
					5: "Game",
					6: "Other",
					7: "Kleidung",
					8: "Beauty",
					9: "Auto",
					10: "Elektronik",
					11: "Schmuck",
					12: "Küche & Haus",
					13: "Office",
					14: "Pet Supply",
				};
				this.material.categoryName = categoryNames[this.material.category];

				//Data Prep

				//1. MarketAccountHistory
				//each stock's marketaccountstock must be assigned a set of five (sorted from 0 to 5) PriceStateHistory objects
				// this is used in the popper, and also in the main table (merchPrice, PS, etc. of priceState with HistoryId := 0).

				for (let stock of this.material.stocks) {
					for (let mas of stock.marketaccountstocks) {
						var history = [];

						for (let pri of this.material.priceInfoHistories) {
							var matchingMA = pri.marketAccountId == mas.marketAccountId;
							var matchingCondition =
								pri.articleCondition == mas.articleCondition;

							if (matchingMA && matchingCondition) {
								history.push(pri);
							}

							//sort histories by HistoryId, descending

							history.sort((v, w) => {
								return Number(v.historyId) - Number(w.historyId);
							});

							mas.priceInfoHistories = history;
						}

						for (let marketAccountId in this.material.marketMirrorData) {
							if(marketAccountId == mas.marketAccountId) {
                mas.marketMirrorData = {};

                let lowestOffers = this.material.marketMirrorData[marketAccountId]?.competingOffers?.lowestOffers
                if (lowestOffers) {
                  lowestOffers.forEach(
                      (offer) => {
                        if (offer.condition == mas.articleCondition) mas.marketMirrorData[offer.fulfillmentMethod] = offer.price - this.material.ownShippingFee[marketAccountId];
                      }
                  );
                }

                let buyBoxPrices = this.material.marketMirrorData[marketAccountId]?.competingOffers?.buyBoxPrices
                if (buyBoxPrices) {
                  buyBoxPrices.forEach(
                      (buyBoxPrice) => {
                        if (buyBoxPrice.condition == mas.articleCondition) mas.marketMirrorData.buyBoxPrice = buyBoxPrice.price;
                      }
                  );
                }
							}
						}
					}
				}

				//sort stocks according to pruchasePrices
				this.material.stocks.sort((v, w) => {
					return Number(v.purchasePrice) - Number(w.purchasePrice);
				});

				// MarketAccountStock data prep, sets:
				// mas.priceState, mas.priceStateColor, mas.currencySymbol
				for (let stock of this.material.stocks) {
					for (let mas of stock.marketaccountstocks) {
						//we could do this calc in the above loop, but for the sake of readability, it is split.
						//Shouldn't cost more than a few milliseconds (like 7 at most).
						var currencyIso = mas.marketaccount.country.currencyIso;
						// +++ Currency Symbol data prep
						if (currencyIso == "EUR") {
							mas.currencySymbol = "€";
						} else if (currencyIso == "USD") {
							mas.currencySymbol = "$";
						} else if (currencyIso == "GBP") {
							mas.currencySymbol = "£";
						} else {
							mas.currencySymbol = currencyIso;
						}

						// +++ PS text color data prep
						mas.priceState = null;

						if (mas.priceInfoHistories.length == 0) {
							mas.priceState = 0;
						} else {
							mas.priceState = mas.priceInfoHistories[0].priceState;
						}

						mas.priceStateStyle = "black";

						if (mas.priceState != null) {
							if (mas.priceState >= 50 && mas.priceState <= 65) {
								mas.priceStateStyle = "green";
							} else if (
								(mas.priceState >= 70 && mas.priceState <= 75) ||
								(mas.priceState >= 20 && mas.priceState <= 25) ||
								(mas.priceState >= 30 && mas.priceState <= 35)
							) {
								mas.priceStateStyle = "orange";
							} else {
								mas.priceStateStyle = "red";
							}
						}
					}
				}

				//strip Material for Edit Material Component:
				this.materialEditMaterial = {
					id: this.material.id,
					ean: this.material.ean,
					eans: this.material.eans,
					upc: this.material.upc,
					isbn: this.material.isbn,
					asin: this.material.asin,
					category: this.material.category,
					name: this.material.name,
					description: this.material.description,
					producer: this.material.producer,
					isBlocked: this.material.isBlocked,
					isUndeliverable: this.material.isUndeliverable,
					needsMetaData: this.material.needsMetaData,
					inMaterialSince: this.material.inMaterialSince,
					priority: this.material.priority,
					currentState: this.material.currentState,
					lastUpdateTime: this.material.lastUpdateTime,
					lastUpdateUser: this.material.lastUpdateUser,
					lastUpdateReason: this.material.lastUpdateReason,
				};
			})
			.catch((error) => {
				alert(
					"Netzwerkfehler: Verbindung zum MDSS konnte nicht aufgebaut werden."
				);
				console.error(error);
			});
	},

	mounted() {
		// alters url pathname without redirecting
		window.history.pushState("", "", "/material/" + this.materialId + "/edit");
		//see: window.history.replaceState(data, title, url)
		//web: stackoverflow.com/q/12446317
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				this.tHeight = window.innerHeight - 140;
			});
			setTimeout(() => this.$refs.refEanSearch.focus(), 2000);
		});
	},
};
</script>